export default {
  "config": {
    "trial": "itc",
    "id": "cgi-c",
    "type": "design",
    "title": "Forest Plot of CGI-C Outcomes Relative to (A) Solriamfetol <no-break>150 mg</no-break> and (B) Solriamfetol <no-break>300 mg</no-break> at 12 Weeks<sup>6</sup><sup>,a<sup>",
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "<sup>a</sup>Bold formatting indicates that the 95% CrI does not cross the line of no effect. Results refer to an odds ratio of at least minimal improvement."
    ],
    "useFootnoteTooltip": true
  },
  "data": {
    "trial": "itc",
    "id": "cgi-c",
    "data-type": "design",
    "title": "Forest Plot of CGI-C Outcomes Relative to (A) Solriamfetol <no-break>150 mg</no-break> and (B) Solriamfetol <no-break>300 mg</no-break> at 12 Weeks<sup>6</sup><sup>,a<sup>",
    "footnote-tooltip": "enable",
    "footnote-order": [
      "footnote-note1",
      "footnote-note2"
    ],
    "footnote-note1": "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
    "footnote-note2": "<sup>a</sup>Bold formatting indicates that the 95% CrI does not cross the line of no effect. Results refer to an odds ratio of at least minimal improvement."
  }
};